import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { CircleCheck } from 'lucide-react'
import { HighlightAppIcon } from '@renderer/components/Icons/HighlightAppIcon'

interface ToastIconProps {
  children: ReactNode
  className?: string
  subIcon?: ReactNode
}

export function ToastIcon({ children, className, subIcon }: ToastIconProps) {
  const iconElement = (
    <div className={twMerge('text-foreground flex items-center justify-center text-lg [&_svg]:size-6', className)}>
      {children}
    </div>
  )

  if (!subIcon) return iconElement

  return (
    <div className="relative">
      {iconElement}
      <div className="absolute -bottom-1 -right-1 flex items-center justify-center">{subIcon}</div>
    </div>
  )
}

export function ToastHighlightIcon({ className }: { className?: string }) {
  return (
    <div
      className={twMerge(
        'bg-background ring-border/10 flex size-6 items-center justify-center rounded-lg ring-1 ring-inset [&_svg]:!size-4',
        className,
      )}
    >
      <HighlightAppIcon />
    </div>
  )
}

export function ChatCompleteIcon() {
  return <div className="size-2.5 rounded-full bg-[#3B82F6]" />
}

export function ToastHighlightSuccessIcon({ className }: { className?: string }) {
  return (
    <div className="relative">
      <ToastHighlightIcon className={className} />
      <CircleCheck className="fill-success absolute -bottom-1 -right-1 size-3 stroke-white" />
    </div>
  )
}
